import {
  StoryDocument,
  ProfileValueOption,
  ProfileFields,
} from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { ResolverFunction } from './resolvers.config';
import { FieldConfig, ProfilePageConfig } from '../types/profile.types';
import { createFieldConfig, DOCUMENT_CONFIGS } from '../utils/fields.helpers';

export const STORY_FIELD_CONFIGS: Partial<FieldConfig> = {
  documentsStoryVideos: createFieldConfig({
    key: 'documentsStoryVideos',
    type: { variant: 'DOCUMENT', fileUploadConfig: DOCUMENT_CONFIGS.story },
  }),
  documentsStoryVideosGroup: createFieldConfig({
    key: 'documentsStoryVideosGroup',
    type: { variant: 'STORY_VIDEO', fileUploadConfig: DOCUMENT_CONFIGS.story },
    width: 'full',
  }),
};

export const STORY_PAGE_CONFIG: ProfilePageConfig = {
  title: 'Story',
  description: 'Add videos that tell your story.',
  sections: [
    {
      title: 'Add a new story',
      description:
        'Share a few snippets of your work. Looking for ideas or prompts? You can answer student questions and more on our VideoAsk page.',
      keys: ['documentsStoryVideos'],
    },
    {
      title: 'Videos',
      keys: ['documentsStoryVideosGroup'],
    },
  ],
};

export const STORY_HELPERS: Partial<
  Record<ProfileFields, ResolverFunction<string | number | ProfileValueOption | StoryDocument>>
> = {
  documentsStoryVideos: () => [],
  documentsStoryVideosGroup: (profile) => profile.profile.documentsStoryVideos || [],
};
